import { $http } from './index';

export function getTicket(pumaToken = '', platformId = '') {
    return $http.post('/md/sso/getTicket', {
        token: pumaToken,
        platformId
    });
}

export function loginByTicket(ticket = '', platformId = '') {
    return $http.post('/md/auth/loginByTicket', {
        ticket,
        platformId
    });
}
